import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { db, auth } from "./firebaseConfig";
import { doc, getDoc } from "firebase/firestore";
import { onAuthStateChanged } from "firebase/auth";
import Navbar from "./Navbar";
import "./ViewQuiz.css";

const ViewQuiz = () => {
  const { quizId } = useParams();
  const [quiz, setQuiz] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [authorUsername, setAuthorUsername] = useState("Unknown");
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const checkauth = onAuthStateChanged(auth, (currentUser) => {
      if (!currentUser) {
        navigate("/login");
      } else {
        setUser(currentUser);
      }
    });

    return () => checkauth();
  }, [navigate]);

  useEffect(() => {
    const fetchQuiz = async () => {
      if (!user) return;

      try {
        const quizRef = doc(db, "quizzes", quizId);
        const quizSnap = await getDoc(quizRef);

        if (quizSnap.exists()) {
          const quizData = quizSnap.data();

          if (!quizData.public && quizData.authorId !== user.uid) {
            setError("This quiz is private. You do not have permission to view it.");
          } else {
            setQuiz(quizData);

            if (quizData.authorId) {
              const userRef = doc(db, "users", quizData.authorId);
              const userSnap = await getDoc(userRef);
              if (userSnap.exists()) {
                setAuthorUsername(userSnap.data().username || "Unknown");
              }
            }
          }
        } else {
          setError("Quiz not found!");
        }
      } catch (err) {
        setError("Failed to load quiz. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    fetchQuiz();
  }, [quizId, user]);

  if (loading) {
    return <p>Loading quiz...</p>;
  }

  if (error) {
    return <p>{error}</p>;
  }

  return (
    <>
      <Navbar />
      <div className="view-quiz-container" >
        <h2 className="view-quiz-title">{quiz.title}</h2>
        <p className="view-quiz-desription"><strong>Description:</strong> {quiz.description}</p>
        <p><strong>Author:</strong> {authorUsername}</p>
        <p><strong>Public:</strong> {quiz.public ? "Yes" : "No"}</p>
        <p><strong>Total:</strong> {quiz.questions?.length || quiz.flashcards?.length}</p>
        <p><strong>Quiz Type:</strong> {quiz.quizType === "flashcards" ? "Flashcards Mode" : "Standard Mode"}</p>

        {/* Display Flashcards Mode */}
        {quiz.quizType === "flashcards" ? (
          <div>
            <h3>Flashcards:</h3>
            <button onClick={() => navigate(`/take-quiz/${quizId}`)}>Learn Flashcards</button>
            <div className="flashcard-grid">
              {quiz.flashcards.map((flashcard, index) => (
                <div key={index} className="flashcard-card">
                  <p><strong>Front:</strong> {flashcard.front}</p>
                  <p><strong>Back:</strong> {flashcard.back}</p>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <div>
            <h3>Questions:</h3>
            <button onClick={() => navigate(`/take-quiz/${quizId}`)}>Start Quiz</button>
            <div className="questions-list">
              {quiz.questions.length > 0 ? (
                quiz.questions.map((q, index) => (
                  <div key={index} className="question-item">
                    <p><strong>Q{index + 1}:</strong> {q.question}</p>

                    {/* Multiple Choice */}
                    {q.type === "multiple-choice" && q.options.length > 0 && (
                      <div className="option-list">
                        {q.options.map((option, i) => (
                          <div key={i} className="option-item">{option}</div>
                        ))}
                      </div>
                    )}

                    {/* True/False */}
                    {q.type === "true-false" && (
                      <div className="option-list"> 
                        <div className="option-item">True</div>
                        <div className="option-item">False</div>
                      </div>
                    )}

                    {/* Open-Ended */}
                    {q.type === "open-ended" && (
                      <p className="option-item italic-text"></p>
                    )}
                  </div>
                ))
              ) : (
                <p>No questions available.</p>
              )}
            </div>
          </div>
        )}


      </div>
    </>
  );
};

export default ViewQuiz;